import { FC } from "react";
import { CardItemType } from "../../model";

const CardItem: FC<CardItemType> = ({
  imgSrc,
  infoName,
  infoDesc,
  numericInfo,
}) => {
  return (
    <div className="card-item">
      <img src={imgSrc} alt="card-source-image" />

      <div className="card-info">
        <div className="info-name">{infoName}</div>
        <div className="info-desc">{infoDesc}</div>
      </div>

      <span className="info-numeric">{numericInfo}</span>
    </div>
  );
};

export default CardItem;
